import { render, staticRenderFns } from "./classificator-tiptap-editor-area.vue?vue&type=template&id=479ec402&scoped=true"
import script from "./classificator-tiptap-editor-area.vue?vue&type=script&lang=js"
export * from "./classificator-tiptap-editor-area.vue?vue&type=script&lang=js"
import style0 from "./classificator-tiptap-editor-area.vue?vue&type=style&index=0&id=479ec402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ec402",
  null
  
)

export default component.exports